import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import socials from "../footer_var";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I am Goutom Roy, a passionate <b className="purple">Flutter Developer</b> with a deep interest in building complex and scalable mobile applications.
              <br />
              <br />
              My focus is on building efficient, maintainable apps using
              <i>
                <b className="purple"> Flutter, BLOC, Provider, Riverpod.</b>
              </i>
              <br />
              <br />
              I have hands-on experience in designing and developing real-world applications like
              <b className="purple"> StylOn (Salon Vendor App)</b>,
              <b className="purple"> DMS (Sales & Distribution App)</b>, and
              <b className="purple"> VMS (Vehicle Tracking App)</b>.
              <br />
              <br />
              I follow clean architecture principles and apply
              <b className="purple"> dependency injection</b>,
              <i>
                <b className="purple"> Freezed, Dio, REST APIs</b>
              </i>, and other modern tools in my development workflow.
              <br />
              <br />
              Whenever possible, I also enjoy learning new technologies, optimizing performance, and contributing to team projects.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1 className="purple">FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              {
                socials.map((e) => {
                  return <li className="social-icons">
                    <a
                      href={e.href}
                      target="_blank"
                      rel="noreferrer"
                      className="icon-colour  home-social-icons"
                    >
                      <e.icon />
                    </a>
                  </li>
                })
              }


            </ul>
          </Col>
        </Row>
      </Container>
    </Container>

  );
}


export default Home2;


